module.exports = __webpack_public_path__ + "static/media/automatedcontent_section1.01a22228.png";